import { HttpClient } from '../../protocols/http/httpClient'
import { GetComprehensiveReportsUseCase } from '../../../domain/usecases/Reports'
import { ReportData } from '../../../pages/Reports/types'
import { validateHttpStatus } from '../../../validation/validateHttpResponse'

export class RemoteGetComprehensiveReports
  implements GetComprehensiveReportsUseCase
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  @validateHttpStatus
  async execute(): Promise<ReportData> {
    return this.httpClient.get?.({
      url: `${this.url}/reports/comprehensive-report`
    })
  }
}
